import { render, staticRenderFns } from "./ServiceSpecialist.vue?vue&type=template&id=eb784556&scoped=true"
import script from "./ServiceSpecialist.vue?vue&type=script&lang=js"
export * from "./ServiceSpecialist.vue?vue&type=script&lang=js"
import style0 from "./ServiceSpecialist.vue?vue&type=style&index=0&id=eb784556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb784556",
  null
  
)

export default component.exports